/* Packages */
import React from "react";
import {observer} from "mobx-react-lite";
import compareStore from "../store";

/* Datalayers */
import pushCompareEvent from "../../datalayers/pushCompareEvent";

/* Components */
import { CompareIcon, ChevronIconRight } from "../../common/Icons";

const CompareCount = observer(({comparingUrl, navMobileMeta }) =>  {
    const compareItems = compareStore.compareItems;

    const url = new URL(window.location.origin + comparingUrl);
    const searchParams = url.searchParams;

    compareItems.forEach(vehicle => {
        searchParams.append('uuid[]', vehicle.id);
    });

    /* Render */
    return (
        <>
            { navMobileMeta ? (
                <li className="menu__item nav-item nav-item--root nav-item--parent w-100">
                    <div className="d-flex justify-content-between align-items-center">
                        <a href={url.href} onClick={() => pushCompareEvent(compareItems.length)} className="d-flex justify-content-between nav-link nav-text text-white w-100">
                            <span className="nav-text-wrapper nav-text">Vergelijken</span>
                            <ChevronIconRight className="icon icon--24 icon--compare"/>
                        </a>
                    </div>
                </li>
            ) : (
                <li className="list__item list__item--compare m-0 p-0 d-none d-lg-flex">
                    <a className="list__link test py-0" href={url.href} onClick={() => pushCompareEvent(compareItems.length)} title="Vergelijken">
                        <span className={`list__link--icon ${compareItems.length > 0 ? 'active' : ''}`}>
                          <CompareIcon className="icon icon--24 icon--compare" />
                        </span>
                        <span className={`d-inline-flex icon__indicator font-weight-semi-bold ${compareItems.length > 0 ? 'active' : ''}`}>
                            {compareItems.length > 0 ? `${compareItems.length}` : ''}
                        </span>
                    </a>
                </li>
            )}
        </>
    );
});

const ObservingCompareItems = observer((props) => {
    return (
        <CompareCount
            {...props}
        />
    );
});

export { CompareCount, ObservingCompareItems };
